import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M19 21a1 1 0 00-.89.55l-.5 1a.81.81 0 01-.74.46h-1.74a.81.81 0 01-.74-.46l-.5-1A1 1 0 0013 21H3a1 1 0 00-.77.37 1 1 0 00-.23.83l.38 1.8a5 5 0 004.9 4h17.44a5 5 0 004.9-4l.38-1.8a1 1 0 00-.21-.83A1 1 0 0029 21z"/><path d="M18 9a1 1 0 01-1 1h-2a1 1 0 010-2h2a1 1 0 011 1z"/><path d="M6 8a1 1 0 011-1h18a1 1 0 011 1v13h2V8a3 3 0 00-3-3H7a3 3 0 00-3 3v13h2z"/>';
export var LaptopSVG = function LaptopSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
LaptopSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(LaptopSVG);